import React from "react";
import { RoomUnit } from "../../CreateUnit_Form/room_unit";
import styled from "styled-components/macro";

const TuluUnitExpended = ({
  itemsCount,
  columns,
  colorUnit,
  logoImage,
  buildingName,
  location,
  headLine,
  isCarpenter,
}) => {
  const Wrapper = styled.div`
    position: relative;
    // background: rgba(242, 244, 234, 1);
  `;

  const UnitWrapper = styled.div`
    margin-top: 72px;
    /* display: flex;
    position: absolute;
    justify-content: center; */
  `;

  const TextWrapper = styled.div`
    flex-direction: column;
    display: flex;
    position: relative;
    justify-content: center;
    margin-left: 97px;
    text-align: left;
  `;

  const ParaOne = styled.p`
    font-size: 50px;
    font-weight: bold;
    font-family: "Lexend", serif;
    margin: 0px;
    text-transform: uppercase;
    text-align: left;
  `;

  const Title = styled.p`
    font-size: 40px;
    font-weight: bold;
    font-family: "Lexend", serif;
    margin: 0px 0 0;
    text-align: left;
  `;

  return (
    <Wrapper>
      <div style={{ flex: 1 }}>
        <TextWrapper>
          <Title>{buildingName}</Title>
          <ParaOne> {headLine} </ParaOne>
        </TextWrapper>
      </div>
      <UnitWrapper style={{ marginLeft: isCarpenter && -280 }}>
        <RoomUnit
          itemsCount={itemsCount}
          columns={columns}
          colorUnit={colorUnit}
          logoImage={logoImage}
        />
      </UnitWrapper>
    </Wrapper>
  );
};

export { TuluUnitExpended };
